import { useDashboardInfo } from "@/api/master-param";
import { H3 } from "@/components/ui/typography";

export default function TabDashboardInfo() {
  const { data } = useDashboardInfo();
  const infoValue = data?.content[0]?.value ?? "No Info Available";

  return (
    <div className="flex flex-col gap-y-8">
      <H3>Dashboard Linknet - Info</H3>
      <div dangerouslySetInnerHTML={{ __html: infoValue }}></div>
    </div>
  );
}
